import React from 'react';
import { useSelector } from 'react-redux';
import FnBOrdersTabDetail from '../../components/dashboard/tab-details/fnb-orders-tab-detail/FnB-Orders-Tab-Detail';
import HouseKeepingTabDetail from '../../components/dashboard/tab-details/house-keeping-tab-detail/House-Keeping-Tab-Detail';
import InRoomDiningTabDetail from '../../components/dashboard/tab-details/in-room-dining-tab-detail/In-Room-Dining-Tab-Detail';
import OccupancyTabDetail from '../../components/dashboard/tab-details/occupancy-tab-detail/Occupancy-Tab-Detail';
import RestaurantTabDetails from '../../components/dashboard/tab-details/restaurant-tab-detail/Restaurant-Tab-Details';
import SpaTabDetails from '../../components/dashboard/tab-details/spa-tab-detail/Spa-Tab-Details';
import {
  FNB_ORDERS,
  HOUSEKEEPING,
  OCCUPANCY,
  SPA,
  TABLE_RESERVATION,
} from '../../constants/DashboardConst';
import { RBAC_PERMISSION_LEVEL_FULL_ACCESS } from '../../constants/RoleConsts';
import CustomIconBox from '../../shared/custom-icon-box/Custom-Icon-Box';
import { dashboardFnbIrdModeSelector } from './DashboardSlice';
import DashboardHousekeeping from './dashboard-housekeeping/DashboardHousekeeping';
import DashboardRestaurant from './dashboard-restaurant/DashboardRestaurant';
import DashboardFnb from './dashboard-fnb/DashboardFnb';
import DashboardSpa from './dashboard-spa/DashboardSpa';

const DailyActivity = (props) => {
  const {
    activeTab,
    onClickTab,
    onClickView,
    dailyActivity,
    userRolePermissions,
    showLoader = () => {},
  } = props;
  const dashboardIrdMode = useSelector(dashboardFnbIrdModeSelector);

  return (
    <>
      <div className='d-flex horizontal-scroll-styled flex-wrap py-2'>
        {dailyActivity?.map((activity, activityNdx) => (
          <div key={activityNdx}>
            <CustomIconBox
              activityNdx={activityNdx}
              icon={activity.icon}
              title={activity.name}
              isActive={activity.isActive}
              onClickTab={onClickTab}
              iconType={activity.iconType}
              iconSelected={activity.iconSelected}
            />
          </div>
        ))}
      </div>
      {activeTab !== OCCUPANCY && (
        <p className="mt-3 mb-2 range-description">
          Displaying data from the last 30 days
        </p>
      )}
      {activeTab && (
        <div className='pb-3'>
          <div className='detail-tab'>
            {/*In this, both components focus on one component, so it's commented out and directly added to that one component below.
             {activeTab === FNB_ORDERS &&
              (dashboardIrdMode ? (
                userRolePermissions.inRoomDiningDashboard ===
                  RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                  <div>
                    <InRoomDiningTabDetail />
                  </div>
                )
              ) : (
                <FnBOrdersTabDetail />
              ))} */}
            {activeTab === FNB_ORDERS && (
              <DashboardFnb
                showLoader={showLoader}
                permissions={userRolePermissions}
              />
            )}
            {activeTab === SPA && (
              <div>
                <DashboardSpa
                  showLoader={showLoader}
                  permissions={userRolePermissions}
                />
              </div>
            )}
            {activeTab === TABLE_RESERVATION && (
              <div>
                <DashboardRestaurant
                  showLoader={showLoader}
                  permissions={userRolePermissions}
                />
              </div>
            )}
            {activeTab === HOUSEKEEPING && (
              <div>
                <DashboardHousekeeping
                  showLoader={showLoader}
                  permissions={userRolePermissions}
                />
              </div>
            )}
            {activeTab === OCCUPANCY && (
              <OccupancyTabDetail
                showLoader={showLoader}
                permissions={userRolePermissions}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default DailyActivity;
